import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHomeowners = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="currentColor"><path d="M27.78 28.017h-1.974V22.06c0-1.99-1.618-2.072-3.612-2.072-1.996 0-3.614.08-3.614 2.072v5.957H4.264c-.588 0-1.066-.586-1.066-1.31V15.083l11.8-.112 1.4-1.388H13.88L22 6.984l6.8 6.612v13.353a1.068 1.068 0 0 1-1.02 1.068z" /><path d="M30.18 13.284a1.063 1.063 0 0 0 1.508 0 1.07 1.07 0 0 0 0-1.51l-7.46-7.47a1.06 1.06 0 0 0-.76-.32H8.53a1.066 1.066 0 0 0-.754.311L.311 11.774a1.07 1.07 0 0 0 .754 1.824h14.934a1.062 1.062 0 0 0 .754-.314l6.713-6.72 6.712 6.72z" /></g></svg>;
export default SvgHomeowners;